import styled from 'styled-components'

export const ToggleWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
`

export const Switch = styled.label<{ checked: boolean }>`
  cursor: pointer;
  text-indent: -9999px;
  width: 44px;
  height: 24px;
  background: ${({ checked }) => (checked ? '#fac532' : '#d6d6d6')};
  display: block;
  border-radius: 10px;
  position: relative;
  border: 1px solid transparent;

  &:after {
    content: '';
    position: absolute;
    left: ${({ checked }) => (checked ? 'calc(55% - 1px)' : '4px')};
    top: 3px;
    width: 18px;
    height: 18px;
    background: #fff;
    border-radius: 90px;
    transition: 0.3s;
  }
`
